import styled from "styled-components";

export const StyledCronSetupDetails = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledCronSetupContent = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
`;

export const StyledCronSetupText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCronSetupModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const StyledTextLink = styled.a`
  color: ${(p) => p.theme.link};
`;
